import {
  EditTransactionRuleProvider,
  type UseEditTransactionRule,
} from './EditTransactionRuleContext';
import { EditTransactionRuleSteps } from './EditTransactionRuleSteps';

export type EditTransactionRuleModalContentProps = Pick<
  UseEditTransactionRule,
  | 'cancelEdit'
  | 'submitEdit'
  | 'transactionRule'
  | 'onLearnMoreClick'
  | 'transactionModifications'
>;

export const EditTransactionRuleModalContent = ({
  onLearnMoreClick,
  transactionRule,
  transactionModifications,
  cancelEdit,
  submitEdit,
}: EditTransactionRuleModalContentProps) => {
  return (
    <EditTransactionRuleProvider
      onLearnMoreClick={onLearnMoreClick}
      transactionRule={transactionRule}
      transactionModifications={transactionModifications}
      cancelEdit={cancelEdit}
      submitEdit={submitEdit}
    >
      <EditTransactionRuleSteps />
    </EditTransactionRuleProvider>
  );
};
